import { OtherPreferences } from "@/clients/models/OtherPreferences";
import { OtherPreferencesService } from "@/clients/services/OtherPreferencesService";
import { QueryKeys } from "@/constants/query-keys";
import { guardGetUserFromLocalStorage } from "@/utils/request";
import { useQuery } from "@tanstack/react-query";

interface UseGetOtherPreferencesOptions {
  enabled?: boolean;
}

/**
 * Hook to fetch other preferences for the current user
 *
 * @param options - Query options including enabled flag
 * @returns Object containing other preferences data, loading state, and error
 */
export const useGetOtherPreferences = (options?: UseGetOtherPreferencesOptions) => {
  const { data, isLoading, error } = useQuery({
    queryKey: [QueryKeys.OTHER_PREFERENCES],
    queryFn: async () => {
      const user = guardGetUserFromLocalStorage();
      const response = await OtherPreferencesService.getOtherPreferencesApiV1OtherPreferencesGet(
        user.id,
      );
      return response.data;
    },
    enabled: options?.enabled ?? true,
  });

  return {
    otherPreferences: data as OtherPreferences | undefined,
    isLoading,
    error,
  };
};
